import { AbstractControl, ValidationErrors } from '@angular/forms';

export function validatePhone(c: AbstractControl): ValidationErrors | null {
    let PHONE_REGEX = /^[0-9]{3}( |-|\.)?[0-9]{3}( |-|\.)?[0-9]{4}$/;

    // If the value of the control tests against the regex, there is no error (return null).
    return c.value == null || c.value == '' || PHONE_REGEX.test(c.value)
        ? null
        : {
            validatePhone: {
                valid: false,
            },
        };
}
